import type { TicketProps } from '~/types/Production';

export const isEventPricingFree = (SyncPricing: Array<TicketProps>) =>
  SyncPricing?.every(
    (pricing) => pricing.PriceZoneA <= 0 && pricing.PriceZoneB <= 0 && pricing.PriceZoneC <= 0,
  );
